
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 2.167h11.084A.583.583 0 0115 2.75v8.75m-13.417-7h10.5c.322 0 .584.261.584.583v8.167a.583.583 0 01-.584.583h-10.5A.583.583 0 011 13.25V5.083c0-.322.261-.583.583-.583zm4.084 2.738v3.856a.175.175 0 00.265.146l3.152-1.928a.171.171 0 000-.292L5.932 7.092a.175.175 0 00-.265.146z","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    